import { defineAsyncComponent } from 'vue'
import { isChunkLoadError, triggerChunkReloadOnce } from '~/utils/chunkErrors'

const MAX_ATTEMPTS = 3
const RETRY_DELAY_MS = 400

/**
 * Async component with retries for transient chunk / dynamic import failures.
 */
export function createLazyComponent(loader, label = 'component') {
    return defineAsyncComponent({
        loader,
        onError(error, retry, fail, attempts) {
            console.error(`Error loading ${label} (attempt ${attempts}):`, error)

            if (attempts < MAX_ATTEMPTS && isChunkLoadError(error)) {
                setTimeout(() => retry(), RETRY_DELAY_MS * attempts)
                return
            }

            fail()

            if (isChunkLoadError(error)) {
                triggerChunkReloadOnce(error)
            }
        },
    })
}
